import { render } from "./AppTwoCol.vue?vue&type=template&id=d34d83e2&scoped=true"
import script from "./AppTwoCol.vue?vue&type=script&lang=js"
export * from "./AppTwoCol.vue?vue&type=script&lang=js"

import "./AppTwoCol.vue?vue&type=style&index=0&id=d34d83e2&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d34d83e2"]])

export default __exports__